module.exports = __webpack_public_path__ + "img/P11.f99f933f.png";